export function getDiscreteIoCompletionMode(action = {}) {
    const explicitMode = String(action?.completionMode || "").trim();
    if (explicitMode === "sensor" || explicitMode === "timer" || explicitMode === "ignore") {
        return explicitMode;
    }

    const doneConditions = Array.isArray(action?.doneConditions) ? action.doneConditions : [];
    if (doneConditions.length > 0) return "sensor";

    const timeoutSec = Number(action?.timeoutSec);
    if (Number.isFinite(timeoutSec) && timeoutSec > 0) return "timer";

    return "ignore";
}
